export default "__VITE_ASSET__BEO0MIeQ__"